import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardTitle,
} from "@/shared/ui/card"
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/shared/ui/dialog"
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@/shared/ui/table"
import { Button } from "@/shared/ui/button"
import AddToken from '@/features/profile/AddToken'
import { useSelector } from "react-redux";
import { formatTimestamp } from "@/shared/lib/appHelpers"
import { getTokenCount } from "@/api/rtk/userSelectors"
import { ProfileWrapper } from '@/shared/components/CardWrapper'
import { useTranslation } from "react-i18next";
import TokenUsage from '@/features/profile/ProfileTokenUsage';
import { useGetTransactionsQuery } from "@/api/rtk/profileApi"

const Billing = () => {
  const { t } = useTranslation();
  const { data } = useGetTransactionsQuery();
  const transactions = data?.transactions || [];
  const orgTokens = useSelector(getTokenCount);
  const [addTokenOpen, setAddTokenOpen] = useState(false);

  const getTokens = (transaction) => {
    const tokens = transaction.tokens?.toLocaleString('en') || 0;
    if (!tokens) return <span className="text-xs">{t("tokens.pending")}</span>;
    return transaction.type === "invoice" ? `+${tokens} ${t("tokens.title")}` : `-${tokens} ${t("tokens.title")}`;
  }

  return (
    <ProfileWrapper
      title={t("profile.tabs.billing")}
      description={t("profile.billing.description")}
      hasButton={false}
    >
      <CardContent className="p-0 w-full">
        <Card className="flex px-4 py-3 justify-between items-center rounded-2xl h-[76px] shadow-none">
          <div>
            <CardDescription className="text-[14px] font-semibold text-[#71717a]">
              {t("profile.billing.tokenBalance")}
            </CardDescription>
            <CardTitle className="mt-1 text-xl tracking-wider">{orgTokens?.toLocaleString('en')}</CardTitle>
          </div>
          <Dialog open={addTokenOpen} onOpenChange={setAddTokenOpen}>
            <DialogTrigger asChild>
              <Button className="font-medium">{t("profile.billing.addTokens")}</Button>
            </DialogTrigger>
            <DialogContent className="rounded-3xl">
              <AddToken setIsOpen={setAddTokenOpen} />
            </DialogContent>
          </Dialog>
        </Card>
        <div>
          <p className="text-black w-fit md:w-full font-SuisseIntlLight font-semibold text-base my-3 mt-5">
            {t("profile.billing.transactionHistory")}
          </p>
          <Card className="rounded-2xl w-full">
            {transactions?.length > 0 ? (
            <Table className="w-full rounded-[20px]">
              <TableBody>
                {transactions?.map((transaction, index) => (
                  <TableRow key={index}>
                    <TableCell className="text-[12px] text-[#09090B] font-semibold">
                      <div className="md:hidden">
                        <p className="text-[#71717A] font-SuisseIntlLight font-medium text-xs">
                          {t(`profile.billing.types.${transaction.type}`)}
                        </p>
                        <h1 className="font-SuisseIntlLight font-semibold text-base">
                          {formatTimestamp(transaction.created_at, 'd/m/y/h')}
                        </h1>
                      </div>
                      <div className="hidden md:block">
                        {formatTimestamp(transaction.created_at, 'd/m/y/h')}
                      </div>
                    </TableCell>
                    <TableCell className="hidden md:table-cell text-[12px] text-[#09090B] font-semibold">
                      {t(`profile.billing.types.${transaction.type}`)}
                    </TableCell>
                    <TableCell className="text-right text-[#09090B] font-semibold">
                      <span className="hidden md:inline text-[12px] tracking-wider">
                        {getTokens(transaction)}
                      </span>
                      <span className="md:hidden text-base tracking-wider">
                        {getTokens(transaction)}
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            ) : (
              <div className="flex justify-center items-center w-full h-40">
                <p className={`p-4 text-center text-sm md:text-xl font-medium text-[#71717A] flex items-center justify-center`}>
                  {t("profile.billing.noInvoices")}
                </p>
              </div>
            )}
          </Card>
          <TokenUsage />
        </div>
      </CardContent>
    </ProfileWrapper>
  );
};

export default Billing;